import React from 'react';

function Anchor(){
    return(
        <div className="anchor">
          <h3>S</h3>
          <h3>C</h3>
          <h3>R</h3>
          <h3>O</h3>
          <h3>L</h3>
          <h3>L</h3>
          <div id="space"></div>
          <h3>D</h3>
          <h3>O</h3>
          <h3>W</h3>
          <h3>N</h3>
        </div>
    )
}

export default Anchor;